module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="btn-group dropup">\n  <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">\n    <span class="gmf-mouseposition-control-target"></span>\n  </button>\n  <ul class="dropdown-menu dropdown-menu-right" role="menu">\n    <li class="dropdown-header" translate>Coordinate systems</li>\n    <li ng-repeat="projitem in ::ctrl.projections">\n      <a href ng-click="ctrl.setProjection(projitem)">\n        <span class="fa fa-fw" ng-class="{\'fa-check\': ctrl.projection == projitem}"></span>\n        {{::projitem.label}}\n      </a>\n    </li>\n  </ul>\n</div>\n';

}
return __p
}